import { memo } from "react";

interface AeroplaneProps {
  variant?: string;
}

const AeroplaneComponent = ({ variant }: AeroplaneProps) => {
  return (
    <img
      src={process.env.PUBLIC_URL + `/images/aeroplane.svg`}
      alt=""
      height="100"
      width="100"
      className={`aeroplane${variant ? ` -${variant}` : ""}`}
      aria-hidden="true"
    />
  );
};

const Aeroplane = memo(AeroplaneComponent);

export default Aeroplane;
